const MXN = new Intl.NumberFormat('es-MX', {
  style: 'currency',
  currency: 'MXN',
  maximumFractionDigits: 2,
});

const NUM = new Intl.NumberFormat('es-MX', {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

const DATE = new Intl.DateTimeFormat('es-MX', {
  year: 'numeric',
  month: 'short',
  day: '2-digit',
});

const DATETIME = new Intl.DateTimeFormat('es-MX', {
  year: 'numeric',
  month: 'short',
  day: '2-digit',
  hour: '2-digit',
  minute: '2-digit',
});

export const fmt = {
  money: (n: number) => MXN.format(n ?? 0),
  num:   (n: number) => NUM.format(n ?? 0),
  date:  (d: string | Date) => DATE.format(d instanceof Date ? d : new Date(d)),
  datetime: (d: string | Date) => DATETIME.format(d instanceof Date ? d : new Date(d)),
};
